import { api } from "./httpClient";

export const roomService = {
  list(tenantId) {
    return api(`/rooms?tenantId=${encodeURIComponent(tenantId || "")}`);
  },
  get(id) {
    return api(`/rooms/${encodeURIComponent(id)}`);
  },
  save(payload) {
    return api("/rooms", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  remove(id) {
    return api(`/rooms/${id}`, { method: "DELETE" });
  },
  restore(uuid) {
    return api(`/rooms/${uuid}/restore`, { method: "POST" });
  },
};
